import React from 'react'
import FollowUs from '../follow-us'
import ContactDetails from '../contact-details'
import { MRF_CONTACTS } from '../../constants/mrf-contacts'
import { PRIVACY_NOTICE_URL } from '../form-signin/privacy-settings'
import Newsletter from '../newsletter'
import styles from './index.module.css'
import { Button, Typography, Link } from '@material-ui/core'
import logo from '../../constants/mrf-logo'
import cn from 'classname'
import { useStaticQuery } from 'gatsby'
import get from 'lodash/get'

export default ({}) => {
  const disabled = true
  const linkColumns = [
    [
      { label: 'Economia', href: '/economia/1/' },
      { label: 'Fiscalità', href: '/fiscalita/1/' },
      { label: 'Lavoro', href: '/lavoro/1/' },
    ],
    [
      { label: 'Legalità', href: '/legalita/1/' },
      { label: 'News', href: '/lista/articoli/1/' },
      { label: 'Politica', href: '/politica/1/' },
    ],
    [
      { label: 'Primo piano', href: '/' },
      { label: 'Sanità', href: '/sanita/1/' },
      { label: 'Video', href: '/lista/video/1/' },
    ],
    [
      { label: 'Chi siamo', href: '/mrf/' },
      { label: 'Documenti', href: '/documenti/' },
      { label: 'Informativa privacy', href: PRIVACY_NOTICE_URL },
    ],
  ]

  const data = useStaticQuery(graphql`
    query LegalInfo {
      contentfulInformazioniLegali {
        email1
        email2
        indirizzo
        numeroTelefonico
        nome
        pIva
      }
    }
  `)
  const legalInfo = get(data, 'contentfulInformazioniLegali') || {}
  // Keep any additional CMS contacts until their function has been verified.
  // Compare only complete values: a field with several contacts is preserved.
  const normalizeContact = value => {
    const text = String(value).trim().toLowerCase()
    if (text.includes('@')) return text
    const digits = text.replace(/\D/g, '')
    return digits.replace(/^(?:0039|39)(?=\d{9,11}$)/, '')
  }
  const knownContacts = MRF_CONTACTS.map(contact => normalizeContact(contact.value))
  const additionalContacts = [legalInfo.numeroTelefonico, legalInfo.email1, legalInfo.email2]
    .filter(Boolean)
    .filter(value => !knownContacts.includes(normalizeContact(value)))
    .filter((value, index, contacts) => contacts.indexOf(value) === index)
  return (
    <div className={styles.container}>
      <FollowUs />
      {!disabled && <Newsletter />}
      <div className={styles.linksContainer}>
        <div className={styles.gridContainer}>
          <nav className={styles.linksGrid} aria-label="Collegamenti del sito MRF">
            {linkColumns.map((column, columnIndex) => (
              <div className={styles.linkColumn} key={columnIndex}>
                {column.map(link => (
                  <Link className={styles.link} href={link.href} key={link.label}>
                    {link.label}
                  </Link>
                ))}
              </div>
            ))}
          </nav>
        </div>
      </div>
      <div className={styles.logoContainer}>
        <div className={cn(styles.bottomBorderSection, styles.gridContainer)}>
          <div className={styles.footerActions}>
            <Link
              href="/"
              className={styles.logoLink}
              aria-label="Torna alla home page del Movimento Rivoluzione Fiscale"
            >
              <img
                src={logo}
                alt={'Logo ufficiale Movimento Rivoluzione Fiscale'}
                className={styles.logo}
              />
            </Link>
            <Button
              classes={{
                root: styles.buttonGreen,
              }}
              href="/iscriviti/"
            >
              Iscriviti
            </Button>
          </div>
          <Typography variant={'body1'} className={styles.copyright}>© 2020</Typography>
        </div>
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.firstRowLegalInfo}>
          <Typography>{[legalInfo.nome, legalInfo.indirizzo, legalInfo.pIva].filter(Boolean).join(' - ')}</Typography>
        </div>
        <ContactDetails className={styles.publicContacts} />
        {additionalContacts.length > 0 && (
          <div className={styles.additionalContacts}>
            <Typography>Altri recapiti già pubblicati:</Typography>
            {additionalContacts.map(value => <Typography key={value}>{value}</Typography>)}
          </div>
        )}
        <div className={styles.secondRowLegalInfo}>
          <Link href="/statistiche-privacy/">Statistiche del sito e riservatezza</Link>
        </div>
      </div>
    </div>
  )
}


